import React from 'react';
import { Link } from 'react-router-dom';
import { useTenantThemeConfig } from '../hooks/useTenantThemeConfig';
import { getCdnBaseUrl } from '../utils/cdnUtils';
import { getThemeAssetUrl } from '../utils/themeUtils';

export const ContactPage: React.FC = () => {
  const { themeConfig } = useTenantThemeConfig();
  
  // Debug: log theme config to see API data
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 ContactPage - themeConfig:', themeConfig);
    console.log('🔍 ContactPage - contactInfo from API:', themeConfig?.settings?.contactInfo);
  }
  
  // Get contact info from tenant config (from API) or use defaults
  const contactInfo = themeConfig?.settings?.contactInfo || {
    line: '@lenhuay',
    lineUrl: 'https://line.me/ti/p/@lenhuay',
    phone: '',
    email: ''
  };

  // Use lineUrl from API or generate from LINE ID as fallback
  const lineId = contactInfo.line || '@lenhuay';
  const lineLink = contactInfo.lineUrl || (
    lineId.startsWith('@') 
      ? `https://line.me/ti/p/${lineId}` 
      : `https://line.me/ti/p/@${lineId}`
  );

  const getAssetUrl = (path: string) => {
    const base = getCdnBaseUrl();
    return getThemeAssetUrl(base, themeConfig?.themeId, path);
  };

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <Link to="/" className="txt-link-d">
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </Link>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-address-card me-2"></i>
                      ติดต่อเรา
                    </div>

                    <div className="bgg-1 bdc-1 bdr-5 px-2 py-2 c-white text-center">
                      <div className="row mx--1">
                        <div className="col-12 px-1">
                          <a
                            href={lineLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-100 mx-auto my-3"
                            style={{ maxWidth: '120px' }}
                          >
                            <img src={getAssetUrl('/img/line_logo.png')} alt="" />
                          </a>

                          <a
                            href={lineLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="t-medium c-white txt-f mx-auto"
                            style={{ width: 'fit-content' }}
                          >
                            <h3 className="bgc-4 c-red px-2 bdr-5 jackpot">
                              {lineId}
                            </h3>
                          </a>

                          <h4 className="my-3">
                            <span className="t-medium">กดที่ ICON LINE ได้เลย</span> <br />
                            เรามีพนักงานรอต้อนรับลูกค้าตลอด 24 ชั่วโมง
                          </h4>

                          <div className="bgg-2 c-red py-2 bdr-5 t-medium">
                            ติดต่อให้ความช่วยเหลือ ตอบคำถาม แก้ไขปัญหาตลอด 24 ชั่วโมง
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};